<!-- Navbar -->
<app-navbar></app-navbar>

<!--Page Header-->
<!-- <div id="page-head" class="mb-10"> -->
<div class="flex-grow">
  <div class="mb-10 banner-container">
    <div class="grid grid-cols-12">
      <div class="col-span-12">
        <div class="w-full h-[450px] banner-wrapper">
          <img src="/assets/images/banners/terms.jpg" alt="" class="object-cover w-full h-full">
          <div class="flex items-center h-full banner-container-inner">
            <div class="container mx-auto">
              <div class="p-[30px] text-center mt-[7em]">
                <h1 class="my-0 mb-2 text-[2em] sm:text-5xl md:text-[2.5em] text-white">
                  <span class="font-bold mr-2">Terms & Conditions</span>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Page Content-->
<section class="w-full min-h-screen mt-10">
  <div class="container mx-auto">
    <div class="flex flex-wrap">
      <div class="w-full mt-10 mb-10">
        <div class="container mx-auto px-6 py-12">
          <div class="bg-white p-3 lg:p-8 rounded-lg mt-[-87px]">
            <h1 class="text-3xl font-bold text-gray-800 mb-0">Terms and Conditions</h1>

            <p class="mb-0 mt-2">
              Welcome to <span class="font-semibold">MedEase</span>. These Terms and Conditions govern your access to
              and use of our online healthcare platform and services. By using MedEase, you agree to comply with and be
              bound by the following terms. If you do not agree with these terms, please do not use our platform.
            </p>

            <h2 class="text-2xl font-semibold text-gray-800 mb-0 mt-2"> Platform Use</h2>
            <p class="mb-4">
              MedEase provides users with access to healthcare professionals for online consultations, appointment
              bookings, and healthcare management. The platform is intended for personal use only, and any commercial
              use is strictly prohibited without prior written consent.
            </p>

            <h3 class="text-xl font-semibold text-gray-700 mb-0">Eligibility:</h3>
            <p class="mb-0 mt-2">You must be at least 18 years of age to use MedEase. If you are under 18, you may use
              the platform only with the involvement of a parent or guardian.</p>

            <h3 class="text-xl font-semibold text-gray-700 mb-0">Account Registration:</h3>
            <p class="mb-6 mt-2">
              To access certain features of MedEase, you may be required to create an account. You agree to provide
              accurate, complete, and up-to-date information during registration and to update such information as
              needed. You are responsible for maintaining the confidentiality of your login credentials.
            </p>

            <h2 class="text-2xl font-semibold text-gray-800 mb-0"> Medical Disclaimer</h2>
            <p class="mb-4 mt-2">
              MedEase is a platform that connects users with healthcare providers. All healthcare services and
              consultations are provided by licensed professionals, but MedEase itself is not a healthcare provider. The
              information and services available on the platform should not replace medical advice, diagnosis, or
              treatment from a qualified healthcare provider.
            </p>

            <h3 class="text-xl font-semibold text-gray-700 mb-0">No Emergency Services:</h3>
            <p class="mb-6 mt-2">
              MedEase is not suitable for medical emergencies. In the event of an emergency, please contact your local
              emergency services immediately.
            </p>

            <h2 class="text-2xl font-semibold text-gray-800 mb-0"> Appointment Scheduling and Consultations</h2>
            <p class="mb-4 mt-2">
              MedEase allows you to schedule and participate in consultations with healthcare professionals. By booking
              an appointment, you agree to the following:
            </p>

            <ul class="list-disc list-inside mb-6 leading-[1.7]">
              <li class="leading-[1.8]"><strong>Timeliness:</strong> You are responsible for attending your scheduled
                appointments at the designated time. Failure to do so may result in cancellation fees.</li>
              <li class="leading-[1.8]"><strong>Cancellations:</strong> You may cancel or reschedule appointments based
                on the provider’s cancellation policy, which will be communicated at the time of booking.</li>
              <li class="leading-[1.8]"><strong>Consultation Quality:</strong> While we strive to connect you with
                qualified professionals, MedEase is not responsible for the quality of care provided by individual
                healthcare providers.</li>
            </ul>

            <h2 class="text-2xl font-semibold text-gray-800 mb-0"> Payments and Fees</h2>
            <p class="mb-4 mt-2">Fees for healthcare services are determined by the providers and may vary depending on
              the service. By booking an appointment or consultation, you agree to pay the applicable fees.</p>

            <h3 class="text-xl font-semibold text-gray-700 mb-0">Payment Methods:</h3>
            <p class="mb-4 mt-2">MedEase accepts payment via credit cards and other payment methods as listed on the
              platform. You agree to provide accurate billing information and authorize us to charge your payment method
              for any services booked.</p>

            <h3 class="text-xl font-semibold text-gray-700 mb-0">Refunds:</h3>
            <p class="mb-6 mt-2">
              Refunds for cancelled appointments will be subject to the provider's refund policy. MedEase is not
              responsible for issuing refunds for services rendered by healthcare providers.
            </p>

            <h2 class="text-2xl font-semibold text-gray-800 mb-0"> User Conduct</h2>
            <p class="mb-6 mt-2">
              By using MedEase, you agree to:
            </p>

            <ul class="list-disc list-inside mb-6">
              <li class="leading-[1.8]">Use the platform only for lawful purposes.</li>
              <li class="leading-[1.8]">Not use the platform to harass, defraud, or harm any other user or provider.
              </li>
              <li class="leading-[1.8]">Not share, post, or transmit any harmful or illegal content, including offensive
                language, threats, or privacy violations.</li>
              <li class="leading-[1.8]">Comply with all applicable laws and regulations in connection with your use of
                the platform.</li>
            </ul>

            <h2 class="text-2xl font-semibold text-gray-800 mb-0"> Privacy</h2>
            <p class="mb-6 mt-2">
              MedEase values your privacy. Please refer to our <a href="/privacy-policy"
                class="text-[#45a6d1] hover:text-black ease-in duration-300 underline">Privacy Policy</a> for details on
              how we collect, use, and protect your personal information. By using MedEase, you consent to the data
              practices described in our Privacy Policy.
            </p>

            <h2 class="text-2xl font-semibold text-gray-800 mb-0"> Third-Party Links</h2>
            <p class="mb-6 mt-2">
              MedEase may contain links to third-party websites or services. These links are provided for your
              convenience and do not constitute an endorsement by MedEase. We are not responsible for the content or
              practices of third-party websites and recommend that you review their terms and policies.
            </p>

            <h2 class="text-2xl font-semibold text-gray-800 mb-0"> Intellectual Property</h2>
            <p class="mb-6 mt-2">
              All content available on MedEase, including text, graphics, logos, and software, is the intellectual
              property of MedEase or its licensors. You are granted a limited license to access and use this content for
              personal purposes only. You may not reproduce, distribute, modify, or create derivative works without our
              express permission.
            </p>

            <h2 class="text-2xl font-semibold text-gray-800 mb-0"> Limitation of Liability</h2>
            <p class="mb-6 mt-2">
              To the fullest extent permitted by law, MedEase and its affiliates shall not be liable for any indirect,
              incidental, special, or consequential damages arising from your use of the platform or the services
              provided by healthcare professionals, including but not limited to loss of data, financial loss, or damage
              to your device.
            </p>

            <h2 class="text-2xl font-semibold text-gray-800 mb-0"> Indemnification</h2>
            <p class="mb-6 mt-2">
              You agree to indemnify and hold MedEase, its affiliates, and its employees harmless from any claims,
              liabilities, damages, or expenses arising out of your use of the platform, your violation of these Terms
              and Conditions, or any third-party claims related to your use of healthcare services through the platform.
            </p>

            <h2 class="text-2xl font-semibold text-gray-800 mb-0"> Changes to These Terms</h2>
            <p class="mb-6 mt-2">
              We reserve the right to modify these Terms and Conditions at any time. Any changes will be communicated
              through the platform, and your continued use of MedEase constitutes acceptance of the revised terms.
            </p>

            <h2 class="text-2xl font-semibold text-gray-800 mb-0"> Termination</h2>
            <p class="mb-6 mt-2">
              MedEase reserves the right to suspend or terminate your account at any time for any reason, including
              violation of these Terms and Conditions or misuse of the platform. Upon termination, you are no longer
              authorized to access MedEase or use its services.
            </p>
<!-- 
            <h2 class="text-2xl font-semibold text-gray-800 mb-0"> Governing Law</h2>
            <p class="mb-6 mt-2">
              These Terms and Conditions shall be governed by and construed in accordance with the laws of <span
                class="font-semibold">[Insert Jurisdiction]</span>. Any disputes arising from these terms will be
              subject to the exclusive jurisdiction of the courts in <span class="font-semibold">[Insert
                Jurisdiction]</span>.
            </p> -->
            <h2 class="text-2xl font-semibold text-gray-800 mb-0"> Contact Us</h2>
            <p class="mt-2">
              For any questions or concerns regarding these Terms and Conditions, please contact us at:
            </p>
            <ul class="list-disc list-inside mb-0">
              <li class="leading-[1.8]">Email: <a href="mailto:[sales@onetikk.com]"
                  class="text-[#45a6d1] hover:text-black ease-in duration-300 underline">sales&#64;onetikk.com</a></li>
              <li class="leading-[1.8]">Phone: <span class="font-semibold">+91 9446062493</span></li>
            </ul>
          </div>
        </div>

      </div>
    </div>

  </div>
</section>

<!-- Footer -->
<app-message></app-message>
<app-footer></app-footer>